import { mapGetters } from 'vuex'

const MIXIN_PTO_CURRENT_PROJECT = {
  computed: {
    ...mapGetters('pto/project', {
      currentProject: 'getCurrentItem'
    })
  }
}

export {
  MIXIN_PTO_CURRENT_PROJECT
}
